import api from '../utils/api'
import {CommonResponse} from "../@types/api";

export const couponService = {
    Redeem(data: string): Promise<CommonResponse> {
        return api.post('/v1/billing/coupon-redeem', {coupon: data})
    }
}
